module.exports = __webpack_public_path__ + "assets/img/thumb-Rosemary-Health-2-Social-Static-Ad.4ed0ad9b.jpg";